import _ from 'underscore';
import ko from 'knockout';

export default function checkbox(local, attrs, custom) {
  if (!custom.values) {
    throw new Error('pass custom values as [checked-value, not-checked-value] in!');
  }

  if (!_.contains(_.first(custom.values, 2), local())) {
    local(custom.values[1]);
  }

  local.checkbox = ko.computed({
    read: () => {
      return custom.values[0] === local();
    },
    write: (value) => {
      local(custom.values[value ? 0 : 1]);
    },
  });
}
